import { useCurrency } from "@/lib/currency";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

const FLAGS = {
  USD: "🇺🇸", EUR: "🇪🇺", GBP: "🇬🇧", CAD: "🇨🇦", AUD: "🇦🇺",
  INR: "🇮🇳", AED: "🇦🇪", JPY: "🇯🇵", CHF: "🇨🇭", SGD: "🇸🇬", ALL: "🇦🇱",
};

export default function CurrencySelector() {
  const { currency, setCurrency, supported, rates } = useCurrency();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="hidden sm:inline-flex items-center gap-1.5 h-8 px-2.5 rounded-full border border-border text-xs font-medium hover:bg-neutral-50 transition"
          data-testid="currency-selector"
          aria-label="Display currency"
        >
          <span aria-hidden="true">{FLAGS[currency] || "🌐"}</span>
          {currency}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div className="font-medium text-sm">Display currency</div>
          <div className="text-xs text-neutral-500">Charged in EUR at checkout</div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {supported.map((c) => {
          const rate = rates?.[c];
          return (
            <DropdownMenuItem
              key={c}
              onClick={() => setCurrency(c)}
              className={c === currency ? "bg-blue-50 text-blue-700 font-semibold" : ""}
              data-testid={`currency-option-${c}`}
            >
              <span className="mr-2 w-5 inline-block" aria-hidden="true">{FLAGS[c] || "🌐"}</span>
              <span className="flex-1">{c}</span>
              <span className="text-xs text-neutral-500 ml-2 tabular-nums">{rate ? `1 EUR = ${Number(rate).toFixed(c === "JPY" || c === "INR" ? 1 : 4)}` : ""}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
